import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation  } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import Services from "./components/services";
import About from "./components/about";
import Teams from "./components/Teams";
import Contact from "./components/contact";
import Intern from "./components/intern"
import Medical from "./sections/medical";
import Careers from "./sections/careers";
import JobDetail from "./sections/JobDetail";
import JobApplicationForm from "./sections/JobApplicationForm";
import Blogs from "./sections/Blogs";
import BlogDetail from "./sections/BlogDetail";
import ScrollToTop from '../src/components/ScrollToTop';
import OurTech from "../src/components/OurTech"
import OurTools from "../src/components/OurTools"
import UrimaiDetails from "./sections/UrimaiDetails";
// import NidhiDetails from "./sections/NidhiDetails";
import ServicesLayout from "./components/ServicesLayout";
import Portfolio from "./components/Portfolio";
import AOS from 'aos';
import 'aos/dist/aos.css';
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const RemoveTrailingSlash = () => {
  const location = useLocation();
  if (location.pathname.endsWith('/') && location.pathname !== '/') {
    return <Navigate to={location.pathname.slice(0, -1)} replace />;
  }
  return null;
};

// Component to handle AOS refresh on route changes
const AOSHandler = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Refresh AOS on every route change
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  return null;
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  
  useEffect(() => {
    setLandingPageData(JsonData);
    
    // Initialize AOS globally once
    AOS.init({
      duration: 1000,
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <RemoveTrailingSlash />
        <AOSHandler />

        <div>
          <Navigation />
          <Routes>
            <Route path="/teams" element={<Teams />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/ourtech" element={<OurTech />} />
            <Route path="/our-products" element={<OurTools />} />
            <Route path="/ourtools" element={<OurTools />} />
            <Route path="/our-products/urimai" element={<UrimaiDetails />} />
            <Route path="/ourtools/urimai" element={<UrimaiDetails />} />
            {/* <Route path="/our-products/nidhi" element={<NidhiDetails />} /> */}
            {/* <Route path="/ourtools/nidhi" element={<NidhiDetails />} /> */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/interns" element={<Intern />} />
            <Route path="/medical" element={<Medical />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:jobId" element={<JobDetail />} />
            <Route path="/careers/:jobId/apply" element={<JobApplicationForm />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />

            <Route path="/services/geo-spatial" element={<ServicesLayout />} />

            <Route
              path="/"
              element={
                <>
                  <Header data={landingPageData.Header} />
                </>
              }
            />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
